const KEYS = ["title", "subtitle", "description", "refund_policy", "payment_description"];
export const LANG_LABELS = { en: "English", hi: "हिंदी", mr: "मराठी" };

const hasText = (v) => String(v || "").replace(/<[^>]*>/g, "").trim().length > 0;

export function pageLangs(page) {
  return ["en", ...["hi", "mr"].filter((l) => KEYS.some((k) => hasText(page?.translations?.[l]?.[k])))];
}

// Page with the chosen language's text swapped in; anything not translated stays English.
export function localizePage(page, lang) {
  if (!page || lang === "en") return page;
  const t = page.translations?.[lang] || {};
  const out = { ...page };
  KEYS.forEach((k) => { if (hasText(t[k])) out[k] = t[k]; });
  return out;
}
